
import React from 'react'


import { Helmet } from "react-helmet-async";

export default function SEO({
  title,
  description,
  url,
  image,
  type = "website",
}) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      <meta
        name="keywords"
        content="
          stock trading signals, live trading signals, buy and sell signals,
          stock market signals, intraday trading signals, swing trading signals,
          algo trading signals, technical analysis signals, stock entry and exit signals,
          real-time market updates, stock price alerts, market trend analysis,
          stock market dashboard, portfolio tracking, real-time PnL and LTP updates,
          trading strategy insights, stock watchlist tools, equity and options signals,
          risk management tools
        "
      />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {image && <meta property="og:image" content={image} />}
      {url && <meta property="og:url" content={url} />}
      <meta property="og:type" content={type} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {image && <meta name="twitter:image" content={image} />}

      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="robots" content="index, follow" />
      <meta charSet="UTF-8" />
    </Helmet>
  );
}
